import _ from "lodash";
import React, { useEffect, forwardRef, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  IonPage,
  IonHeader,
  IonContent,
  IonToolbar,
  IonTitle,
} from "@ionic/react";
import { personOutline } from "ionicons/icons";

import AppInitializationPage from "../app-initialization-page";
import AccountSetupWizard from "../account-setup-wizard";
import AppStateDisplay from "../app-state-display";
import {
  retrieveAccountInformation,
  AccountInformationModal,
} from "../../../account";
import { AppBreadcrumb } from "../../components";
import { AppMenu } from "../../containers";

import strings from "../../../../res/strings";

import styled from "styled-components";
const appPages = [
  // {
  //   title: strings.lib_collaboration_title_joined_groups,
  //   url: "/groups",
  //   icon: businessOutline,
  // },
  // {
  //   title: "Your Reservations",
  //   url: "/under-development",
  //   icon: calendarOutline,
  // },
  {
    title: "EMPLOYEE ACCOUNTS",
    url: "/manage-accounts",
    icon: personOutline,
  },
];
const Toolbar = styled(IonToolbar)`
  --background: #00cccc;
  --padding-bottom: 0px;
`;
const ToolbarHeader = styled.div`
  padding-top: 8px;
  background-image: url(${process.env.PUBLIC_URL +
  "assets/images/triumvi-header-bg.png"});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left top -12px;
`;
const ToolbarTitle = styled(IonTitle)`
  margin-top: 8px;
  color: #ffffff;
  font-family: Secular One;
  font-size: 1.7em;
  letter-spacing: 0.05em;
  line-height: 23px;
  text-shadow: 0px 4px 5px rgba(44, 191, 201, 0.5);
`;
const ToolbarSubtitle = styled(IonTitle)`
  color: #ffffff;
  font-family: Secular One;
  font-size: 1em;
  text-shadow: 0px 4px 5px rgba(44, 191, 201, 0.5);
`;
const MasterSlaveLayout = styled.div`
  display: flex;
  height: 100%;
`;

const AuthenticatedPage = (props) => {
  const [accountProfileModalVisible, setAccountProfileModalVisible] = useState(
    false
  );

  useEffect(() => {
    const values = { authtoken: props.credentials.authToken };
    props.retrieveAccountInformation({
      values,
      loadingState: {
        context: "lib_account.retrieveAccountInformation.authenticatedPage",
      },
      successState: {
        context: "lib_account.retrieveAccountInformation.authenticatedPage",
      },
      errorState: {
        notificationType: "alert",
        message: strings.lib_common_state_error,
        context: "lib_account.retrieveAccountInformation.authenticatedPage",
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (
    !props.accountInformation &&
    (_.get(props.isProcessing, "context") ===
      "lib_account.retrieveAccountInformation.authenticatedPage" ||
      _.get(props.error, "context") ===
        "lib_account.retrieveAccountInformation.authenticatedPage")
  ) {
    return <AppInitializationPage />;
  } else if (!props.accountInformation) {
    return <AccountSetupWizard parsedQuery={props.parsedQuery} />;
  }

  const toolbarHeaderComponent = (
    <ToolbarHeader>
      <ToolbarTitle>TRIUMVI</ToolbarTitle>
      <ToolbarSubtitle>BUSINESS MADE EASY.</ToolbarSubtitle>
      <AppBreadcrumb
        breadcrumbPath={props.breadcrumbPath}
        history={props.history}
      />
    </ToolbarHeader>
  );

  return (
    <IonPage>
      <IonHeader>
        <Toolbar>
          {toolbarHeaderComponent}
          {/* <IonButtons slot="start">
            <IonMenuButton autoHide={false}></IonMenuButton>
          </IonButtons> */}
        </Toolbar>
      </IonHeader>
      {/* <MasterSlaveLayout>
        <AppMenu
          appPages={appPages}
          handleOpenAccountProfile={() => {
            setAccountProfileModalVisible(true);
          }}
        />
        <IonContent ref={props.forwardedRef} fullscreen>
          <AppStateDisplay parsedQuery={props.parsedQuery}>
            {props.children}
          </AppStateDisplay>
          <AccountInformationModal
            isOpen={accountProfileModalVisible}
            handleClose={() => {
              setAccountProfileModalVisible(false);
            }}
          />
        </IonContent>
      </MasterSlaveLayout> */}
    </IonPage>
  );
};

const mapStateToProps = (state) => ({
  credentials: state.lib_authentication.credentials,
  accountInformation: state.lib_account.accountInformation,

  processing: state.lib_application.processing,
  success: state.lib_application.success,
  error: state.lib_application.error,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      retrieveAccountInformation,
    },
    dispatch
  );

const ConnectedAuthenticatedPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthenticatedPage);
export default forwardRef((props, ref) => (
  <ConnectedAuthenticatedPage {...props} forwardedRef={ref} />
));
